import React, { Fragment, useState, useRef, useEffect } from "react";
import Moment from "react-moment";
import PropTypes from "prop-types";
import ToggleButton from "../../PlayerButtons/ToggleButton";
import Volume from "./Volume";
import Progress from "./Progress";

import { evaluate } from "../../../utilities/props";

import ProfileModal from "../IME/PostModal";

const JobStreamPost = ({ time, videoduration }) => {
  const [active, setActive] = useState(false);
  time = evaluate(time);
  videoduration = evaluate(videoduration);
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showOverlay, setshowOverlay] = useState(true);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);
  return (
    <Fragment>
      <div className="profile-post">
        <div className="post-top-container">
          <div className="post-type blue">Job Stream</div>
          <div className="post-date">
            {!active && <i className="far fa-clock mr-5 blue"></i>}
            {!active && <Moment format="MM/DD/YYYY">Date</Moment>}
            {active && (
              <div>
                <ProfileModal />
              </div>
            )}
            <i
              className="fas fa-ellipsis-v fa-lg post-info blue"
              onClick={() => {
                if (!active) {
                  setActive(true);
                } else {
                  setActive(false);
                }
              }}
            ></i>
          </div>
        </div>
        <div className="post-header">
          <div className="online-avi-container">
            <div className="avi-color-border blue">
              <div className="drop-down-result-avi"></div>
            </div>
          </div>
          <div className="online-info">
            <ul className="user-online-items">
              <li className="user-online-item">
                <span className="blue name-font">Employer Name</span>
              </li>
              <li className="side-container-user-item">Recruiter Name</li>
            </ul>
          </div>
        </div>
        <div className="post-body">
          <div className="video-view">
            <div
              className={
                showOverlay ? "alt-video-overlay" : "alt-video-overlay-pause"
              }
            >
              <div className="live blue">
                <i className="fas fa-circle mx-5 blue"></i>Live
              </div>
              <div className="left-controls">
                <ul className="controls">
                  <Volume
                    className="Rac__volume"
                    initial={0}
                    onChange={(level) => {
                      const volume = level / 100;
                      videoRef.current.volume = volume;
                      videoRef.current.muted = volume === 0;
                    }}
                  />
                </ul>
              </div>
              <ToggleButton
                className="alt-center-controls"
                value={() => videoRef.current && !videoRef.current.paused}
                onChange={(active) => {
                  if (!active) {
                    return videoRef.current.pause();
                  }

                  return videoRef.current.play();
                }}
              >
                {(active) => {
                  if (currentTime > 0.1 && currentTime < duration && active) {
                    setshowOverlay(true);
                    return (
                      <i
                        className="far fa-pause-circle blue fa-3x"
                        onClick={(e) => videoRef.current.pause()}
                      ></i>
                    );
                  } else {
                    setshowOverlay(false);
                  }
                  if (currentTime === duration) {
                    setCurrentTime(0);
                  } else if (currentTime === 0 && !active) {
                    return (
                      <i
                        className="far fa-play-circle blue fa-3x"
                        onClick={(e) => videoRef.current.play()}
                      ></i>
                    );
                  }
                  return (
                    <i
                      className="far fa-play-circle blue fa-3x"
                      onClick={(e) => videoRef.current.play()}
                    ></i>
                  );
                }}
              </ToggleButton>
              <Progress
                className="Rac__progress-bar"
                initial={0}
                time={currentTime}
                duration={duration}
                onSkip={(time) => (videoRef.current.currentTime = time)}
              />
            </div>
            <video
              ref={videoRef}
              src={
                "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/modeling.mp4"
              }
              className="fill-video"
            ></video>
          </div>
        </div>
        <div className="header-container">
          <div className="post-text">
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ducimus
            veritatis consequuntur ut deleniti unde quasi.
          </div>
        </div>
        <div className="post-footer">
          <div className="post-footer-icons">
            <ul className="footer-icons-alt">
              <li className="footer-icon">
                <i className="far fa-thumbs-up fa-lg blue"></i>
                <span className="footer-icon-text mx-5">54.9k</span>
                <i className="far fa-thumbs-down fa-lg blue"></i>
              </li>
              <li className="footer-icon">
                <i className="far fa-user fa-lg blue"></i>
                <span className="footer-icon-text">34.9k</span>
              </li>
              <li className="footer-icon">
                <i className="fas fa-play-circle fa-lg blue"></i>
                <span className="footer-icon-text">Watch</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default JobStreamPost;
